// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LtPj","rootMobile":"styles_rootMobile__jyCVq"};